import type { Crowd } from './crowd.ts';
import type { SimEvent } from './events.ts';
import type { Layout } from './layout.ts';
import type { LaneRoute } from './route.ts';
import type { Enemy, SimState } from './state.ts';

/** Fixed simulation step. */
export const DT = 1 / 60;
export const TICK_RATE = 60;

/** Everything a system needs during a tick: the state plus constant geometry and scratch space. */
export interface Ctx {
  st: SimState;
  routes: LaneRoute[];
  layout: Layout;
  crowd: Crowd;
  ev: SimEvent[];
  byId: Map<number, Enemy>;
}

export const enemyById = (ctx: Ctx, id: number): Enemy | null => ctx.byId.get(id) ?? null;
export const targetable = (e: Enemy | null): e is Enemy => !!e && e.alive && e.reveal >= 0.85;
